<template>
  <div class="section-block">
    <SectionTitle
      v-if="title || $slots.title"
      :title="title"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot name="title" />
    </SectionTitle>
    <div :class="{ 'mt-[24px]': title || $slots.title }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSectionBlock',
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
